<template>
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		:width="props.width"
		:height="props.height"
		:viewBox="props.viewBox"
		:aria-labelledby="props.iconName"
		role="presentation"
	>
		<title :id="props.iconName" lang="en">{{ props.iconName }} icon</title>
		<g :fill="props.iconColor">
			<slot></slot>
		</g>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconName: string;
		iconColor?: string;
		viewBox?: string;
	}>(),
	{
		width: 28,
		height: 28,
		iconColor: 'currentColor',
		viewBox: '0 0 28 28',
	}
);
</script>

<style lang="scss" scoped>
svg {
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
